import { checkPoint, getConfigWithDefaults } from '@ow/utils'

const defaultOpts = {
  cacheKey: 'id',
  geoKey: 'position',
}

const labelMarkers = (opts) => {
  const { cacheKey, geoKey } = getConfigWithDefaults(defaultOpts, opts)

  const clear = (layer) => () => {
    layer.cache = {}
    layer.labelsLayer.clear()
  }

  const render =
    (AMap, amap, layer) =>
    (data = [], config = {}) => {
      const { onClick, icon, textConfig, autoFit = true } = config

      const markers = data
        .filter(
          (item) =>
            item && !layer.cache[item[cacheKey]] && checkPoint(item[geoKey])
        )
        .map((item) => {
          const { title, icon: itemIcon, textConfig: itemtextConfig } = item
          const text = title
            ? {
                content: title,
                ...textConfig,
                ...itemtextConfig,
              }
            : undefined
          const marker = new AMap.LabelMarker({
            name: item[cacheKey],
            position: item[geoKey],
            zIndex: 16,
            icon: itemIcon || icon,
            text,
          })

          layer.cache[item[cacheKey]] = true

          if (typeof onClick === 'function') {
            marker.on('click', (e) => {
              onClick({ ...e, originData: item })
            })
          }

          return marker
        })
      layer.labelsLayer.add(markers)
      amap.add(layer.labelsLayer)
      console.log('[label-markers]', layer.labelsLayer.getAllOverlays().length)
      if (autoFit) {
        amap.setFitView()
      }
    }

  const setApis = (AMap, amap) => ({
    initLabelMarker: (layer) => {
      layer.cache = {}
      layer.labelsLayer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
        // 该层内标注是否避让
        // collision: true,
      })

      // ---- exposed interface ---------
      layer.render = render(AMap, amap, layer)
      layer.clear = clear(layer)
      // -------------------------------
    },
  })
  return {
    amapPlugins: [],
    setApis,
  }
}

export default labelMarkers
